module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/12e69a59db0f0c697eaaf1abbcad902f.svg";